<!-- 会员关系转移 -->
<template>
    <page>
        <c-dialog ref="memberDialog" :title="title" width="600" height="480" enable-flex @resolve="setMemberHandle">
            <c-form ref="memberForm">
                <c-form title="">
                    <h5>当前操作将会将转出会员【<span style="color: red">{{nickName}}</span>】团队中的<span style="color: red">{{groupUserCount}}</span>个成员，全部转移到接收会员的团队中</h5>
                </c-form>
                <c-form title="转出会员" title-margin="10">
                    <c-form-item type="input" label="会员昵称:" name="nick_name" disabled></c-form-item>
                    <c-form-item type="input" label="会员手机号:" name="user_manage_mobilephone" disabled></c-form-item>
                </c-form>
                <c-form title="接收会员" title-margin="10">
                    <c-form-item type="hidden" name="new_user_id"></c-form-item>
                    <c-form-item type="input" @click="$refs.memberSelector.open()" readonly label="修改为:"
                                 name="tran_share_user_name" required
                                 word="调整后,系统将当前会员下属所有直属邀请会员转移至新会员">
                    </c-form-item>
                </c-form>
            </c-form>
        </c-dialog>
        <member-selector ref="memberSelector" @resolve="selectHandle($event)"></member-selector>
    </page>
</template>

<script>
	import memberSelector from "@/components/service/member_selector.vue";

    export default {
        components: {memberSelector},
		props: {
        },

        data() {
            return {
                platform_user_id:0,
                groupUserCount:0,
                nickName:'',
                title:'团队成员转移',
                serachParams:{}
            }
        },
		
		methods: {
			open(data) {
                this.platform_user_id = data.platform_user_id;
                this.groupUserCount = data.group_user_count||0;
                this.$refs.memberForm.clear();
                this.$refs.memberForm.set({
                    nick_name: data.nick_name,
                    user_manage_mobilephone: data.user_manage_mobilephone
                });
                this.nickName = data.user_manage_mobilephone;
                if (data.nick_name){
                    this.nickName+='('+data.nick_name+')'
                }
                this.$refs.memberDialog.open();
			},

            //选择会员回调方法
            selectHandle(list) {
                var tran_share_user_name = "--";
                var new_user_id = -1;
                if (list && list[0]) {
					tran_share_user_name = (list[0].nick_name || "--") + "【" + (list[0].user_manage_mobilephone || "--") + "】";
                    new_user_id = list[0].platform_user_id || -1;
                }
                this.$refs.memberForm.set({
                    tran_share_user_name: tran_share_user_name,
                    new_user_id: new_user_id,
                });
            },
            //保存调整会员等级
            setMemberHandle(stop) {
                stop();
                this.$refs.memberForm.submit({
                    url: '/member_user/childmove',
                    rule: {
						new_user_id: [{
							type: 'empty',
							word: '请选择接收会员'
						},{
							type: 'function',
							fun: value => {
								return this.platform_user_id != value;
							},
							word: '接收会员与原会员不能相同'
						}]
                    },
                    dataFormatter: data => {
                        data.member_user_id = this.platform_user_id;
                        delete data.tran_share_user_name;
                        return data;
                    },

                    success: (data, res, msg) => {
                        this.$refs.memberDialog.close();
                        this.$confirm({
                            text: msg,  // 提示内容,
                            buttonName: '知道了',  // 确定按钮文字
                            cancelButton: false  // 是否显示取消按钮
                        });
                        //调用响应方法
                        this.$emit('resolve',this.platform_user_id);
                    },
                })
            }
        }
	}
</script>